export const BADGE_TYPE = {
  ACTIVATE: 'activate',
  NEW_FEATURE: 'newFeature',
  NOT_AVAILABLE: 'notAvailable',
  SAVE: 'save',
  TRY_FOR_FREE: 'tryForFree',
  UPGRADE: 'upgrade'
};